import type { Measurement, MeasurementType } from "../types.ts";
import { convertValue } from "../utils/units.ts";

const TYPE_SVG: Record<MeasurementType, string> = {
  distance: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>`,
  area: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>`,
  height: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>`,
  point: `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="9"/></svg>`,
};

const TYPE_LABEL: Record<MeasurementType, string> = {
  distance: "Distance",
  area: "Area",
  height: "Height",
  point: "Point",
};

export class MeasurePanel {
  private el: HTMLElement;
  private listEl: HTMLElement;
  private onDelete?: (id: string) => void;
  private onClick?: (id: string) => void;

  constructor(pane: HTMLElement, onDelete: (id: string) => void, onClick?: (id: string) => void) {
    this.onDelete = onDelete;
    this.onClick = onClick;

    this.el = pane;
    this.el.innerHTML = `
      <div class="mp-list"></div>
      <div class="mp-empty">No measurements yet.<br>Use the toolbar above to measure.</div>
    `;
    this.listEl = this.el.querySelector(".mp-list")!;
  }

  render(measurements: Measurement[]): void {
    this.listEl.innerHTML = "";
    const empty = this.el.querySelector(".mp-empty") as HTMLElement;
    empty.style.display = measurements.length ? "none" : "block";

    for (const m of measurements) {
      const item = document.createElement("div");
      item.className = "mp-item";
      item.dataset.id = m.id;

      let val = "";
      if (m.value != null) {
        const cv = convertValue(m.value, m.type);
        val = `${cv.value.toFixed(2)} ${cv.unit}`;
      }

      item.innerHTML = `
        <span class="mp-icon mp-icon--${m.type}">${TYPE_SVG[m.type]}</span>
        <div class="mp-info">
          <span class="mp-type">${TYPE_LABEL[m.type]}</span>
          <span class="mp-value">${val}</span>
        </div>
        <button class="mp-del" title="Delete" data-id="${m.id}">\u00d7</button>
      `;
      item.addEventListener("click", () => {
        this.onClick?.(m.id);
      });
      item.querySelector(".mp-del")!.addEventListener("click", (e) => {
        e.stopPropagation();
        this.onDelete?.((e.currentTarget as HTMLElement).dataset.id!);
      });
      this.listEl.appendChild(item);
    }
  }

  dispose(): void {
    this.el.innerHTML = "";
  }
}
